import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-custom-rich-text',
    template: `
  <div class="html-widget-iframe-container" #containerRef style="position:relative;">
  </div>
  <div class="overlay" style="top:0;left:0;width:100%;height:100%;position:absolute;" [ngStyle]="{'display': isOverlayAvailable ? 'none' : ''}" (click)="htmlClick()"></div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormlyFieldCustomRichText extends FieldType<FieldTypeConfig> implements AfterViewInit {
  @ViewChild('containerRef', { static: true }) containerRef: ElementRef<HTMLElement>;
  isOverlayAvailable: boolean = false;

  constructor(private renderer: Renderer2) {
    super();
  }

  ngAfterViewInit(): void {
    const iframe: HTMLIFrameElement = this.renderer.createElement('iframe');
    iframe.width = '100%'
    iframe.height = '400px'
    iframe.src = `data:text/html;charset=utf-8,${encodeURIComponent(this.htmlContent)}`
    this.renderer.appendChild(this.containerRef.nativeElement, iframe)
    
  }

  overlayClick() {
    this.isOverlayAvailable = true;
    this.htmlClick(); // Overlay'e tıklandığında deneme fonksiyonunu çağır
  }

  htmlClick() {
    this.isOverlayAvailable = true;
  }

  get type() {
    return this.to.type || 'text';
  }

  get htmlContent(): string {
    return `
    <!DOCTYPE html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=1060, initial-scale=1.0">
        <style>
          * {
            font-family: Helvetica, Arial, sans-serif;
          }
          p {
            color: black;
            font-family: Helvetica, Arial, sans-serif;
          }
          h1, h2, h3, h4, h5, h6 {
          }
          .ql-size-12px {
            font-size: 12px !important;
          }
          .ql-size-14px {
            font-size: 14px !important;
          }
          .ql-size-16px {
            font-size: 16px !important;
          }
          .ql-size-18px {
            font-size: 18px !important;
          }
          .ql-size-20px {
            font-size: 20px !important;
          }
          .ql-size-22px {
            font-size: 22px !important;
          }
          .ql-size-24px {
            font-size: 24px !important;
          }
          .ql-size-26px {
            font-size: 26px !important;
          }
          .ql-size-28px {
            font-size: 28px !important;
          }
          .ql-size-36px {
            font-size: 36px !important;
          }
          .ql-size-48px {
            font-size: 48px !important;
          }
          .ql-size-72px {
            font-size: 72px !important;
          }
        </style>
      </head>
      <body id="content">
        <div>
        ${this.to['html']}
        </div>
      </body>
    </html>`;
  }
}